var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{attrs:{"size":"large","type":"text"},on:{"click":_vm.backHome}},[_vm._v(_vm._s(_vm.langMap.backHome[_vm.lang]))]),_c('Button',{attrs:{"size":"large","type":"text"},on:{"click":_vm.backPrev}},[_vm._v(_vm._s(_vm.langMap.backPrev[_vm.lang])+"("+_vm._s(_vm.second)+"s)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }